class Encrypt {
  _userUids = new Set();

  generateUid(uidLength = 8) {
    // Explanation - https://stackoverflow.com/a/44678459/10963661
    // Benchmark - https://jsben.ch/XDi7m

    const dictionary = "abcdefghijklmnopqrstuvwxyz0123456789";

    // added "u" so that all uids starts with a letter
    // temp solution to solve a bug in regex in lastMatch for retrieving publisher uids
    const uid =
      "u" +
      Array.from({ length: uidLength }).reduce(
        (a) => a + dictionary[Math.trunc(Math.random() * dictionary.length)],
        "",
      );

    if (this._userUids.has(uid)) {
      return this.generateUid(uidLength);
    }
    this._userUids.add(uid);

    return uid;
  }
}

const encrypt = new Encrypt();
export { Encrypt, encrypt };